import React from 'react';
import { BookOpenIcon, CalendarIcon, ClockIcon, CreditCardIcon, FileTextIcon, GiftIcon, LockIcon, PrinterIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { mockupUrl } from '../data/content';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-16" data-id="element-222" data-mp="4mrul1r1q1lr">
      <div className="pointer-events-none absolute left-1/2 top-[18%] h-[540px] w-[540px] -translate-x-1/2 rounded-full bg-accent/10 blur-[110px]" data-id="element-223" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-224" data-mp="xb5whsl99i2l">
        <div className="mb-5 inline-flex rounded-full border border-accent/20 bg-accent/10 px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-primary md:mb-7" data-id="element-225" data-mp="sa9r1al99nv2">
          🏥 Compra Digital Ya™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-extrabold leading-[1.1] tracking-tight text-slate-900 md:text-6xl" data-id="element-226" data-mp="3d2tpjcx5eqg4">
          Tu protocolo de rehabilitación,{' '}
          <span className="text-accent" data-id="element-227" data-mp="3j9u06x1wdkkr">listo desde hoy.</span>
        </h1>
        <a href="#pricing" className="group my-5 flex justify-center rounded-3xl focus:outline-none md:my-7" aria-label="Ver las opciones de compra del Combo Completo Rehabilitación de Lesiones" data-id="element-228" data-mp="3o7vk1k75dnxa">
          <img className="w-full max-w-[620px] object-contain drop-shadow-[0_24px_38px_rgba(3,105,161,.22)] transition-transform duration-300 group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Rehabilitación de Lesiones 2026 con sus 5 tomos y bonos" data-id="element-229" data-mp="3e7ux7oa2kpoc" />
        </a>
        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-slate-600 md:text-xl" data-id="element-230" data-mp="2viy1rh2xrr4j">
          <strong className="text-slate-900" data-id="element-231" data-mp="2hj5i25ptub62">
            COMBO COMPLETO REHABILITACIÓN DE LESIONES 2026.
          </strong>{' '}
          El sistema N°1 para profesores de educación física, entrenadores personales, kinesiólogos y
          personas con lesiones que necesitan un protocolo real, progresivo y listo para aplicar en
          Argentina.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-medium text-slate-600 md:text-sm" data-id="element-232" data-mp="na08cwk1yzd4">
          <span className="flex items-center gap-1.5" data-id="element-233" data-mp="i9vu7d6magq2">
            <FileTextIcon className="h-4 w-4 text-accent" data-id="element-234" data-mp="degdmdh866py" />
            100% PDF
          </span>
          <span className="flex items-center gap-1.5" data-id="element-235" data-mp="1azkutpff0er5">
            <ClockIcon className="h-4 w-4 text-accent" data-id="element-236" data-mp="1622hznya1fdv" />
            Acceso en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-237" data-mp="112g3zcamjv40">
            <CalendarIcon className="h-4 w-4 text-accent" data-id="element-238" data-mp="111543nkav7i6" />
            Edición 2026
          </span>
          <span className="flex items-center gap-1.5" data-id="element-239" data-mp="x0uw65cy670o">
            <PrinterIcon className="h-4 w-4 text-accent" data-id="element-240" data-mp="3ltgoxvs8x0qz" />
            Listo para usar hoy
          </span>
        </div>
        <div className="mt-7" data-id="element-241" data-mp="3hqam6y4cdrp9">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-242" data-mp="3htg7s3dribg8">
            QUIERO EL SISTEMA COMBO COMPLETO REHABILITACIÓN
          </Button>
        </div>
        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-medium text-slate-500 md:text-sm" data-id="element-243" data-mp="21b629t7jkskj">
          <span className="flex items-center gap-1" data-id="element-244" data-mp="2b0pon8ugr4k5">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-245" data-mp="2b1hh4asrkm67" />
            Garantía 7 días
          </span>
          <span className="text-sky-300" data-id="element-246" data-mp="2fzj1r05u8tjs">·</span>
          <span className="flex items-center gap-1" data-id="element-247" data-mp="2kyduouxiryhm">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-248" data-mp="2kx2hk4i6pedu" />
            Pago seguro
          </span>
          <span className="text-sky-300" data-id="element-249" data-mp="2p1a3xv166i8w">·</span>
          <span className="flex items-center gap-1" data-id="element-250" data-mp="2u03kjwbr6pda">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-251" data-mp="2txhe600lmfwn" />
            Mercado Pago
          </span>
        </div>
        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-252" data-mp="zlkj7x2y6rwu">
          <TrustCard icon={<UsersIcon className="h-5 w-5 text-accent" data-id="element-254" data-mp="4b461q1btyhv" />} text="+500 profesionales y personas ya usan el sistema" data-id="element-253" data-mp="znn82dsd6ezz" />
          <TrustCard icon={<BookOpenIcon className="h-5 w-5 text-accent" data-id="element-256" data-mp="3vjrsk9bazrr0" />} text="5 Tomos listos para usar" data-id="element-255" data-mp="3vgvtuirmsz1i" />
          <TrustCard icon={<GiftIcon className="h-5 w-5 text-accent" data-id="element-258" data-mp="99xntunncbnu" />} text="5 Bonos incluidos gratis" data-id="element-257" data-mp="e77j3qxpvhjl" />
          <TrustCard icon={<StarIcon className="h-5 w-5 fill-gold text-gold" data-id="element-260" data-mp="3hqshcjik0jp9" />} text="4.9/5 · ★★★★★" data-id="element-259" data-mp="3hph8446cajqr" />
        </div>
      </div>
    </section>;
}
function TrustCard({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex flex-col items-center gap-2 rounded-2xl border border-sky-100 bg-white p-3 shadow-sm" data-id="element-261" data-mp="3mpn6s4b116ic">
      <span data-id="element-262" data-mp="2yz9ag1leslhy">{icon}</span>
      <span className="text-center text-[11px] font-bold leading-tight text-slate-800 md:text-sm" data-id="element-263" data-mp="2yyhshtkqima5">
        {text}
      </span>
    </div>;
}